import { useState, type FormEvent } from "react";

export default function SubscribeSection() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotVal = (formData.get("phone_alt") as string || "").trim();
    if (honeypotVal) {
      setStatus("success");
      setEmail("");
      return;
    }

    if (!email.trim()) return;

    setStatus("loading");
    setErrorMsg("");

    try {
      const formPayload = new FormData();
      formPayload.append("email", email.trim());

      const response = await fetch("https://readdy.ai/api/form/d9s8paknlsngrm4lmiag", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ email: email.trim() }).toString(),
      });

      const responseText = await response.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && parsed?.code === "OK") {
        setStatus("success");
        setEmail("");
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        setStatus("error");
        setErrorMsg(serverMsg.includes("spam") ? "提交失败，请稍后再试。" : (serverMsg || "提交失败，请检查网络后重试。"));
      }
    } catch {
      setStatus("error");
      setErrorMsg("网络错误，请检查连接后重试。");
    }
  };

  return (
    <section className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <div className="w-16 h-16 mx-auto mb-6 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600">
          <i className="ri-mail-send-line text-2xl"></i>
        </div>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          订阅最新影评资讯
        </h2>
        <p className="text-sm text-foreground-600 mb-8 max-w-md mx-auto">
          第一时间获取「妈妈的朋友2」相关的最新文章、影评分析和观影推荐，不错过任何精彩内容。
        </p>

        {status === "success" ? (
          <div className="flex items-center justify-center gap-3 px-6 py-4 rounded-xl bg-accent-50 border border-accent-200 text-accent-800">
            <i className="ri-checkbox-circle-fill text-xl"></i>
            <span className="text-sm font-medium">订阅成功！感谢你的关注，我们会定期发送精彩内容到你的邮箱。</span>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            data-readdy-form
            className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 max-w-md mx-auto"
          >
            <div className="flex-1 relative">
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="输入你的邮箱地址"
                required
                className="w-full px-5 py-3 rounded-full border border-background-300 bg-background-50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
              />
            </div>
            <button
              type="submit"
              disabled={status === "loading"}
              className="px-7 py-3 bg-primary-500 text-background-50 text-sm font-medium rounded-full hover:bg-primary-600 disabled:opacity-60 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {status === "loading" ? (
                <span className="flex items-center gap-2">
                  <i className="ri-loader-4-line animate-spin"></i>
                  提交中...
                </span>
              ) : (
                "立即订阅"
              )}
            </button>
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              readOnly
              className="anti-spam-field"
            />
          </form>
        )}

        {status === "error" && (
          <p className="mt-4 text-sm text-primary-600">{errorMsg}</p>
        )}

        <p className="mt-6 text-xs text-foreground-500">
          我们尊重你的隐私，不会发送垃圾邮件，你可以随时取消订阅。
        </p>
      </div>
    </section>
  );
}